import { toLower, map, capitalize } from 'lodash';

export function uppercaseSpacedToCapitalized(input:string) {
  // Convert the input string to lowercase and split it into words
  const words = toLower(input).split(' ');

  // Capitalize the first letter of each word
  const capitalizedWords = map(words, capitalize);

  // Join the words to form the capitalized string
  return capitalizedWords.join(' ');
}

/**
 * Formats a string to the specified output format
 * Handles snake_case, kebab-case, PascalCase, UPPER_CASE, space separated words, etc.
 * 
 * @param input The input string to format
 * @param format The desired output format: 
 *   - 'camelCase': first word lowercase, others capitalized with no spaces
 *   - 'PascalCase': all words capitalized with no spaces
 *   - 'Title Case': all words capitalized with spaces
 *   - 'snake_case': all lowercase with underscores
 *   - 'kebab-case': all lowercase with hyphens
 * @returns The formatted string
 */
export function formatString(input: string, format: 'camelCase' | 'PascalCase' | 'Title Case' | 'snake_case' | 'kebab-case' = 'camelCase'): string {
  if (!input) return '';
  
  // Replace special characters with spaces and split into words
  const words = input.replace(/[_\-\s.]+/g, ' ').split(' ');
  
  // Clean words of non-alphanumeric characters
  const cleanedWords = words.map(word => word.replace(/[^\w\s]/g, ''));
  
  switch(format) {
    case 'camelCase':
      return cleanedWords.map((word, index) => {
        if (index === 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join('');
      
    case 'PascalCase':
      return cleanedWords.map(word => 
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      ).join('');
      
    case 'Title Case':
      return cleanedWords.map(word => 
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      ).join(' ');
      
    case 'snake_case':
      return cleanedWords.map(word => word.toLowerCase()).join('_');
      
    case 'kebab-case':
      return cleanedWords.map(word => word.toLowerCase()).join('-');
      
    default:
      return input;
  }
}

/**
 * Converts any string format to camelCase
 * @deprecated Use formatString with 'camelCase' format instead
 */
export function toCamelCase(input: string): string {
  return formatString(input, 'camelCase');
}

